import { Link } from "react-router-dom"

const Header = () => {
  return (
    <div className="top_panel">
      <Link to='/filmroom'><div className="logo" /></Link>
      <div className="menu">
      </div>
    </div>
  )
}

export default Header